export const timeoutList = [
	{
		value: 300,
		label: '5 Minutes',
	},
	{
		value: 900,
		label: '15 Minutes',
	},
	{
		value: 1800,
		label: '30 Minutes',
	},
	{
		value: 3600,
		label: '1 Hour',
	},
];
